import React from 'react';
import { ButtonSecondary } from '@creditas-ui/button';
import { ArrowLeft } from '../../assets/icons/ArrowLeft';

export type ButttonBackProps = {
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
};

const ButtonBack = ({ onClick, ...props }: ButttonBackProps): JSX.Element => {
  return (
    <ButtonSecondary data-testid="button-back" onClick={onClick} type="button" {...props}>
      <ArrowLeft />
    </ButtonSecondary>
  );
};

export { ButtonBack };
